import { render } from "./SubmitSongs.vue?vue&type=template&id=6e780523&scoped=true"
import script from "./SubmitSongs.vue?vue&type=script&lang=js"
export * from "./SubmitSongs.vue?vue&type=script&lang=js"

import "./SubmitSongs.vue?vue&type=style&index=0&id=6e780523&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e780523"]])

export default __exports__